// 화면에 보이는 이름의 기본값.
// 구글 계정의 실명을 그대로 쓰면 화면을 남에게 보여줄 때 실명이 노출되므로,
// 앱 안에서는 언제나 이 닉네임을 쓴다. 설정에서 바꿀 수 있다.
export const DEFAULT_NICKNAME = '푸코';

// 독서 인증에 찍히는 이름.
// 단톡방에서 쓰는 필명이라 화면에 보이는 이름과 따로 둔다.
// 여기가 바뀌면 그동안 올린 인증과 이어지지 않으므로 설정에서 바꾸지 않는다.
export const CERTIFICATION_NAME = '푸코';

// 초기 누적일 값
export const INITIAL_DAYS_KOREAN = 0;
export const INITIAL_DAYS_ENGLISH = 0;
